<template>
  <el-collapse v-model="activeNames" class="expand-collapse__search" @change="handleChange">
    <el-collapse-item :title="collapseTitle" name="expand">
      <slot></slot>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
export default {
  name: "collapse-search",
  data() {
    return {
      activeNames: "collapse",
    };
  },
  computed: {
      collapseTitle() {
        if(this.activeNames[1]=='expand'){
          // $(".el-footer").css("padding-top","0%")
        }else{
          // $(".el-footer").css("padding-top","8%")
        }
        return this.activeNames[1] === 'expand' ? '收起筛选' : '展开筛选'
      }
  },
  methods: {
      handleChange(val) {
          this.$emit('change',val)
      }
  },
  mounted() {
    $("span:contains('导出')").parent("button").css({color:"#1890FF",background:"#ffffff","border-color":"#1890FF"});
    $("span:contains('打印')").parent("button").css({color:"#1890FF",background:"#ffffff","border-color":"#1890FF"});
    $(".el-range-input").parents(".el-form-item__content").css({width:"550px","max-width":"550px"});
    
  }
};
</script>

<style lang="scss">
@import "@/assets/css/element-variables.scss";



/* 查询条件收缩样式 */
.expand-collapse__search {
  border: none;
  .el-collapse-item__header {
    height: 32px;
    line-height: 32px;
    border-bottom: none;
    padding-right: 0px;
    float: right;
    margin-bottom: 0px;
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #1890FF !important;
  }
  .el-collapse-item__wrap {
    border-bottom: none;
  }
  .el-collapse-item__content {
    padding-bottom: 0;
  }
  i{
    display: none;
  }
}

</style>
